const companymanagement = {
  namespaced: true,
  state: {
    activeTab: "general" // ✅ Ensure default is 'general'
  },
  mutations: {
    SET_TAB(state, tab) {
      console.log("✅ Mutation SET_TAB called with:", tab);
      state.activeTab = tab; // ✅ Correctly set the activeTab
    },
    RESET_TAB(state) {
      console.log("✅ Mutation RESET_TAB called");
      state.activeTab = "general"; // ✅ Ensure reset works properly
    }
  },
  actions: {
    changeTab({ commit }, tab) {
      console.log("✅ Action changeTab called with:", tab);
      commit("SET_TAB", tab);
    },
    resetTab({ commit }) {
      console.log("✅ Action resetTab called");
      commit("RESET_TAB");
    }
  }
};

export default companymanagement;
